import { DateTime } from 'luxon'

import { type TimezonesEnum } from '@webapp/core/entities/external/enums/TimezonesEnum'

export const convertISOStringToTimezone = (
  date: ISODateString,
  timezone: TimezonesEnum
): Date => {
  const { day, month, year, hour, minute, second } = DateTime.fromISO(date, {
    zone: timezone,
  }).toObject()

  return new Date(year, month - 1, day, hour, minute, second)
}
